module.exports = __webpack_public_path__ + "img/why-illustration.6b1ecf1d.png";